import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  Backdrop,
  FormControl,
  Select,
  MenuItem,
  Grid,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import TipTapEditor from "../textEditor/TipTapEditor";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const filterStyle = {
  width: "100%",
  mt: "10px",
  "& .MuiInputBase-input": {
    padding: "7px",
    borderRadius: "14px",
    fontSize: "14px",
    border: "none",
  },
  "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
    color: "#673C8E",
  },
  "& .MuiOutlinedInput-root": {
    height: "40px",
  },
  "& .MuiOutlinedInput-root fieldset": {
    border: "2px solid #673C8E",
  },
  "& .MuiOutlinedInput-root fieldset:hover": {
    borderColor: "#673C8E",
  },
  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
    borderColor: "#673C8E",
  },
};

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backdropFilter: "blur(2px)", // Adjust blur strength as needed
  },
  dialogPaper: {
    borderRadius: "0", // Set border radius to 0
    border: "1px solid #000",
  },
  textFieldRoot: {
    "& .MuiInputLabel-root": {
      color: "#8D8D8E !important", // Adding !important to ensure the color overrides
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Initial outlined border color
      },
      "&:hover fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(103, 60, 142, 1)", // Change outlined border color when focused
      },
    },
  },
}));
const DriverContractModal = ({
  onClose,
  open,
  onSubmit,
  view,
  existingData,
  id,
}) => {
  const classes = useStyles();
  const [editorData, setEditorData] = useState({
    content: existingData?.content || "",
    contractVersion: existingData?.contractVersion || "",
    target: existingData?.target ?? "Web & Email",
  });
  // const [validFor, setValidFor] = useState(existingData?.validFor || "");

  useEffect(() => {
    setEditorData({
      content: existingData?.content || "",
      contractVersion: existingData?.contractVersion || "",
      target: existingData?.target ?? "Web & Email",
      createdAt: existingData?.createdAt,
      updatedAt: existingData?.updatedAt,
    });
    // setValidFor(existingData?.validFor || "");
  }, [existingData]);

  const handleSubmit = () => {
    // Handle submission logic, e.g., send editorData to an API
    onSubmit(editorData);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={open} />
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent sx={{ marginTop: "30px", padding: "0 40px" }}>
          <Typography
            id="modal-title"
            sx={{
              fontSize: "30px",
              mb: 2,
              fontWeight: 700,
              textAlign: "center",
            }}
            gutterBottom
          >
            {view ? "View " : id ? "Edit" : "Add "} Driver Contract
          </Typography>
          <Box>
            <Typography color="#683C8C" fontWeight={600} fontSize={"24px"}>
              Contract Version
            </Typography>
            <TextField
              disabled={view}
              placeholder="V1"
              sx={{
                mt: "10px",
                width: "100%",
                "& .MuiInputBase-root": {
                  height: 42,
                  "&.Mui-focused fieldset": {
                    borderColor: "#683C8C",
                  },
                  "& fieldset": {
                    borderColor: "#683C8C",
                  },
                },
              }}
              value={editorData.contractVersion}
              onChange={(e) =>
                setEditorData((data) => ({
                  ...data,
                  contractVersion: e.target.value,
                }))
              }
            />
          </Box>
          <Box sx={{ width: "100%", mt: "10px" }}>
            <Typography color="#683C8C" fontWeight={600} fontSize={"24px"}>
              Target
            </Typography>
            <Select
              size="medium"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              disabled={existingData}
              value={editorData.target}
              onChange={(e) =>
                setEditorData((data) => ({ ...data, target: e.target.value }))
              }
              sx={{
                mt: 1,
                color: "#673C8E",
                width: "100%",
                mb: 1,
                "& .MuiSelect-select": {
                  borderColor: "#673C8E",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#673C8E",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#673C8E",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#673C8E",
                },
              }}
              // onChange={handleChange}
            >
              <MenuItem value="Web & Email">Web & Email</MenuItem>
              <MenuItem value="Mobile">Mobile</MenuItem>
            </Select>
          </Box>
          {view && (
            <Box display="flex" alignItems={"center"} gap="30px" mt={"30px"}>
              <Box width={"100%"}>
                <Typography color="#683C8C" fontWeight={600} fontSize={"24px"}>
                  Created Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    readOnly
                    format="DD MMM YYYY"
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    value={dayjs(editorData?.createdAt)}
                    sx={filterStyle}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Box>
              <Box width={"100%"}>
                {" "}
                <Typography color="#683C8C" fontWeight={600} fontSize={"24px"}>
                  Last Updated
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    readOnly
                    format="DD MMM YYYY"
                    slotProps={{
                      textField: {
                        placeholder: "DD MMM YYYY",
                      },
                    }}
                    value={dayjs(editorData?.updatedAt)}
                    sx={filterStyle}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          )}
          <Box className={classes.editorWrapper} sx={{ mt: 4, mb: 4 }}>
            <TipTapEditor
              value={editorData.content}
              onChange={
                (content) => setEditorData((data) => ({ ...data, content })) // Update state with editor content only if not in view mode
              }
              disabled={view}
            />
          </Box>
          <Box
            sx={{
              marginTop: "47px",
              marginBottom: "38px",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Button
              sx={{
                borderColor: "#683C8C",
                color: "#683C8C",
                padding: "6px 40px",
                fontSize: "15px",
                fontWeight: 400,
                textTransform: "capitalize",
                "&:hover": {
                  borderColor: "#683C8C",
                  backgroundColor: "transparent",
                  color: "#683C8C",
                },
                mr: 1,
              }}
              variant="outlined"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              disabled={view} // Disable button if view is true
              sx={{
                backgroundColor: "#683C8C",
                color: "#FFFFFF",
                padding: "6px 40px",
                fontSize: "15px",
                fontWeight: 400,
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#683C8C",
                  color: "#FFFFFF",
                },
              }}
              variant="contained"
              onClick={handleSubmit}
            >
              {id ? "Update" : "Submit"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DriverContractModal;
